import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonApp, IonRouterOutlet, IonModal } from "@ionic/vue";
import { useAuth } from "@vueuse/firebase/useAuth";
import { auth } from "@/firebase-service";
import LoginPage from "@/views/LoginPage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { isAuthenticated } = useAuth(auth);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet)),
      _createVNode(_unref(IonModal), {
        "is-open": !_unref(isAuthenticated)
      }, {
        default: _withCtx(() => [
          _createVNode(LoginPage)
        ]),
        _: 1
      }, 8, ["is-open"])
    ]),
    _: 1
  }))
}
}

})